// @flow
export const extractNumberFromString = (str: string) => {
  return parseInt(str.match(/\d/g).join(''))
}